<template>
  <div class="new-modal-container">
    <div class="modal-header new-modal-header">
      <table>
        <tr>
          <td style="height: 10px">
            <a
              type="button"
              class="close"
              style="line-height:0;color:black;opacity:1;"
              @click="closeModal()"
              data-dismiss="modal"
            >&times;</a>
          </td>
        </tr>
        <tr>
          <td>
            <h1>Alert from openplan.cy</h1>
          </td>
        </tr>
      </table>
    </div>
    <div>
      <div class="modal-body-expense">
        <div class="row modal-new-body">
          <div class="col-md-12">
            <p>Are you sure you want to delete {{ entity }}?</p>
          </div>
        </div>
        <div class="modal-new-footer">
          <button type="button" class="btn btn-submit" @click="confirmDelete()">Ok</button>
          <button
            type="button"
            class="btn btn-cancel"
            @click="closeModal()"
            data-dismiss="modal"
          >Cancel</button>
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.new-modal-container {
  margin-top: -150px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 6px;
}
.new-modal-header {
  background-color: #fff;
  border: 0px #fff solid;
  border-radius: 6px;
  text-align: center;
  height: 70px !important;
}
h1 {
  color: black;
  font-size: 20px;
}
table {
  width: 104%;
  margin: -10px;
  margin-top: 0px;
}
.modal-new-body {
  padding: 28px;
}
.modal-new-footer {
  text-align: center;
  margin-bottom: 50px;
}
button {
  margin: 2px;
  width: 21%;
}
p {
  text-align: center;
}
</style>
<script>
import { buildingService, expenseTypeService, userService } from '@/_services';
export default {
    props:{
        entityId:Number,
        request:String,
        entity:String,
    },
    methods:{
        closeModal: function(){
            this.$modal.hide('deleteAlert');
        },
        confirmDelete: async function(){
            var confDelete = false;
            var _this = this
            console.log(this.request)
            try {
             switch(this.entity)
             {
                 case "building":
                    await buildingService.deleteBuilding(this.entityId)
                    confDelete = true;
                    this.closeModal();
                    this.$emit("close", confDelete)
                     break;
                 case "user":
                     await userService.deleteUser(this.entityId)
                     confDelete = true;
                     this.closeModal();
                     this.$emit("close", confDelete)
                     break;
                case "expenseType":
                    await expenseTypeService.deleteExpenseType(this.entityId)
                    confDelete = true;
                    this.closeModal();
                    this.$emit("close", confDelete)
                    break;
                    default:
                     await this.axios.delete('/'+ this.request +'/' + this.entityId).then(function () {
                        confDelete = true;
                        _this.closeModal();
                        _this.$emit("close", confDelete)
                    })
             }
            } catch (error) {
                alert("Delete failed: " + error)
            }
            }
        }
    }
</script>